
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("@ember-decorators/utils/-private/class-field-descriptor", function(){ return i("@ember-decorators/utils/-private/class-field-descriptor");});
d("@ember-decorators/utils/collapse-proto", function(){ return i("@ember-decorators/utils/collapse-proto");});
d("@ember-decorators/utils/decorator", function(){ return i("@ember-decorators/utils/decorator");});
import "ember-cli-babel/-embroider-implicit-modules.js";
import "@ember-decorators/utils/-embroider-implicit-modules.js";
